import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SkladND = {
	name: NAME,
	apiProvider,
	router,
};
